// ─────────────────────────────────────────────────────────────
// Agrega esto a tu resources/js/app.js (donde ya inicializas Alpine)
// No reemplaza nada existente, solo se suma.
// ─────────────────────────────────────────────────────────────

import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    BlockQuote,
    CodeBlock,
    List,
    TodoList,
    Indent,
    IndentBlock,
    Alignment,
    FontSize,
    FontFamily,
    FontColor,
    FontBackgroundColor,
    Link,
    LinkImage,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Table,
    TableToolbar,
    TableCaption,
    Mention, // ya queda importado para cuando quieras activar @mentions
    Undo,
    Base64UploadAdapter,
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

/**
 * Adapter de subida de imágenes hacia tu propio backend Laravel.
 * Esto es lo que en CKEditor reemplaza a "CKBox" (que sí es de pago):
 * lo escribimos nosotros y sube el archivo a donde tú quieras.
 *
 * Requiere una ruta Laravel que reciba el archivo y devuelva { url: "..." }.
 * Ver el ejemplo en `ckeditor-upload-controller-example.php`.
 */
class LaravelUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(
            (file) =>
                new Promise((resolve, reject) => {
                    const data = new FormData();
                    data.append('upload', file);

                    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

                    fetch('/toc/image-upload', {
                        method: 'POST',
                        headers: {
                            'X-CSRF-TOKEN': csrfToken,
                            Accept: 'application/json',
                        },
                        body: data,
                    })
                        .then((res) => {
                            if (!res.ok) throw new Error('Fallo al subir la imagen');
                            return res.json();
                        })
                        .then((json) => resolve({ default: json.url }))
                        .catch((err) => reject(err));
                })
        );
    }

    abort() {
        // Si quieres soportar cancelar la subida, aquí abortarías el fetch (AbortController).
    }
}

function LaravelUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => new LaravelUploadAdapter(loader);
}

// Se expone en window para que Alpine (en el blade) pueda usarlo sin bundlear nada aparte.
window.CKEditorTOC = {
    ClassicEditor,
    uploadAdapterPlugin: LaravelUploadAdapterPlugin,
    plugins: [
        Essentials,
        Paragraph,
        Heading,
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        BlockQuote,
        CodeBlock,
        List,
        TodoList,
        Indent,
        IndentBlock,
        Alignment,
        FontSize,
        FontFamily,
        FontColor,
        FontBackgroundColor,
        Link,
        LinkImage,
        Image,
        ImageCaption,
        ImageStyle,
        ImageToolbar,
        ImageUpload,
        Table,
        TableToolbar,
        TableCaption,
        Mention,
        Undo,
        Base64UploadAdapter,
    ],
};


window.addEventListener('error', (event) => {
    if (event.error && event.error.name === 'CKEditorError' && String(event.error.message).includes('unexpected-error')) {
        event.preventDefault(); // evita que se imprima en consola
    }
});